import { Environment } from './environment';

export const environment: Partial<Environment> = {
    all_messages: []
};
